export default __webpack_public_path__ + "static/media/paperFoldedLarge.52da76d5.jpg";